// GENERATED FILE - DO NOT MODIFY
import { WorkOrderWorkTaskDetailsModel } from "api/models/company/workorder/work-order-work-task-details-model";
import { WorkOrderWorkTaskModel } from "api/models/company/workorder/work-order-work-task-model";
import { PagingInfo } from "api/paging-info";
import BaseProxy from "api/proxies/base-proxy";
import ModelDateTransformer from "api/util/model-date-transformer";
import { autoinject } from "aurelia-framework";
import { ApiHelper } from "helpers/api-helper";
import { HttpClientFactory } from "http-client/http-client-factory";
import { HttpClientRequestConfig } from "http-client/http-client-request-config";

@autoinject()
export class WorkOrderWorkTaskProxy extends BaseProxy {
    constructor(modelDateTransformer: ModelDateTransformer, httpClientFactory: HttpClientFactory, apiHelper: ApiHelper) {
        super(modelDateTransformer, httpClientFactory, apiHelper);
    }

    public async GetWorkTasksByDispatchId(dispatchId: number, filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<WorkOrderWorkTaskModel[] | null> {
        const uri = this.buildUri(
            "/dispatch/{dispatchId}/work-task",
            { dispatchId: (dispatchId === null || dispatchId === undefined) ? undefined : dispatchId.toString() },
            { filter: filter ? filter : undefined, page: (pagingInfo && pagingInfo.page ? pagingInfo.page.toString() : undefined), pagesize: (pagingInfo && pagingInfo.pageSize ? pagingInfo.pageSize.toString() : undefined) }
        );

        const data: WorkOrderWorkTaskModel[] | null = await this.get<WorkOrderWorkTaskModel[] | null>(uri, requestConfig);
        this.transformModels(data, "Company.Workorder.WorkOrderWorkTaskModel");
        return data;
    }

    public async GetWorkTasksByWorkOrderId(workOrderId: string | null, filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<WorkOrderWorkTaskModel[] | null> {
        const uri = this.buildUri(
            "/workOrder/{workOrderId}/work-task",
            { workOrderId: (workOrderId === null || workOrderId === undefined) ? undefined : workOrderId },
            { filter: filter ? filter : undefined, page: (pagingInfo && pagingInfo.page ? pagingInfo.page.toString() : undefined), pagesize: (pagingInfo && pagingInfo.pageSize ? pagingInfo.pageSize.toString() : undefined) }
        );

        const data: WorkOrderWorkTaskModel[] | null = await this.get<WorkOrderWorkTaskModel[] | null>(uri, requestConfig);
        this.transformModels(data, "Company.Workorder.WorkOrderWorkTaskModel");
        return data;
    }

    public async GetNewWorkTaskByDispatchId(dispatchId: number, requestConfig?: HttpClientRequestConfig): Promise<WorkOrderWorkTaskDetailsModel | null> {
        const uri = this.buildUri(
            "/dispatch/{dispatchId}/work-task/new",
            { dispatchId: (dispatchId === null || dispatchId === undefined) ? undefined : dispatchId.toString() },
            null
        );

        const data: WorkOrderWorkTaskDetailsModel | null = await this.get<WorkOrderWorkTaskDetailsModel | null>(uri, requestConfig);
        this.transformModels(data, "Company.Workorder.WorkOrderWorkTaskDetailsModel");
        return data;
    }

    public async GetNewWorkTaskByWorkOrderId(workOrderId: string | null, requestConfig?: HttpClientRequestConfig): Promise<WorkOrderWorkTaskDetailsModel | null> {
        const uri = this.buildUri(
            "/workOrder/{workOrderId}/work-task/new",
            { workOrderId: (workOrderId === null || workOrderId === undefined) ? undefined : workOrderId },
            null
        );

        const data: WorkOrderWorkTaskDetailsModel | null = await this.get<WorkOrderWorkTaskDetailsModel | null>(uri, requestConfig);
        this.transformModels(data, "Company.Workorder.WorkOrderWorkTaskDetailsModel");
        return data;
    }

    public async DeleteWorkTask(transactionNumber: number, requestConfig?: HttpClientRequestConfig): Promise<boolean> {
        const uri = this.buildUri(
            "/work-order/work-task/{transactionNumber}",
            { transactionNumber: (transactionNumber === null || transactionNumber === undefined) ? undefined : transactionNumber.toString() },
            null
        );

        const data: boolean = await this.delete<boolean>(uri, requestConfig);
        return data;
    }

    public async GetWorkTask(transactionNumber: number, requestConfig?: HttpClientRequestConfig): Promise<WorkOrderWorkTaskDetailsModel | null> {
        const uri = this.buildUri(
            "/work-order/work-task/{transactionNumber}",
            { transactionNumber: (transactionNumber === null || transactionNumber === undefined) ? undefined : transactionNumber.toString() },
            null
        );

        const data: WorkOrderWorkTaskDetailsModel | null = await this.get<WorkOrderWorkTaskDetailsModel | null>(uri, requestConfig);
        this.transformModels(data, "Company.Workorder.WorkOrderWorkTaskDetailsModel");
        return data;
    }

    public async SaveWorkTask(workTask: WorkOrderWorkTaskDetailsModel | null, requestConfig?: HttpClientRequestConfig): Promise<number> {
        const uri = this.buildUri(
            "/work-order/work-task",
            null,
            null
        );

        const data: number = await this.post<WorkOrderWorkTaskDetailsModel | null, number>(uri, workTask, requestConfig);
        return data;
    }
}
